import { getExtensionDownloadLink, getExtensionIdByHostname } from '../../react/utils/chrome-extension';
import { koComponent } from '../ko-utils';
import { urlize } from '../utils/core';
import $api from '../api';
import { openEditor } from '../common/editorUtils';

class NewExtensionDialog {
    constructor(params, initParams) {
        this.page = initParams;
        this.isInstalled = params.isInstalled;
        this.id = params.id;
        this.type = params.type;

        this.extensionUrl = ko.pureComputed(() => {
            return getExtensionDownloadLink();
        });

        this.applicationUrl = ko.observable(window.auth.project.BaseUrl);
    }

    openEditorExtension() {
        this.applicationUrl(urlize(this.applicationUrl));

        $api.projects.updateAppUrl({ projectCode: window.auth.project.UniqueCode, url: encodeURIComponent(this.applicationUrl()) }, {}, resp => {
        });
        console.log('AA', this);
        chrome.runtime.sendMessage(getExtensionIdByHostname(), {
            type: 'launch-specific-editor',
            payload: {
                url: this.applicationUrl(),
                workspaceCode: window.auth.project.UniqueCode,
                id: this.id,
                type: this.type
            }
        }, function (response) {
            if (chrome.runtime.lastError) {
                console.log('ERROR', chrome.runtime.lastError);
            }
        });
        this.page.closeDialog();
    }

    openLegacyEditorExtension() {
        openEditor(this.type, this.applicationUrl(), this.id, null, true, true);
    }

    cancel() {
        this.page.closeDialog();
    }
}

export default koComponent('new-extension-dialog', NewExtensionDialog);